import DashboardLayout from "@/components/layout/DashboardLayout";
import { Truck } from "lucide-react";
import { TRANSPORTER_IDS } from "@/constants/transporterIds";


export default function TransporterIds() {
  return (
    <DashboardLayout>
      <div className="space-y-5">
        <div className="flex items-center gap-2">
          <Truck className="w-6 h-6 text-brand-500" />
          <h1 className="text-2xl font-bold text-slate-800">Transporter IDs</h1>
        </div>
        <p className="text-sm text-slate-500">
          Reference table for Part-A Eway Bill generation. Select the Transporter ID matching the carrier actually handling the shipment.
        </p>

        <div className="bg-white border border-slate-200 rounded-xl overflow-hidden">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-slate-200 bg-slate-50 text-left text-slate-500">
                <th className="px-4 py-3 font-semibold">Carrier</th>
                <th className="px-4 py-3 font-semibold">Transporter ID</th>
              </tr>
            </thead>
            <tbody>
              {TRANSPORTER_IDS.map((row) => (
                <tr key={row.carrier} className="border-b border-slate-100 last:border-0 hover:bg-slate-50">
                  <td className="px-4 py-3 text-slate-800 font-medium">{row.carrier}</td>
                  <td className="px-4 py-3 font-mono text-slate-600">{row.id}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </DashboardLayout>
  );
}
